module.exports = __webpack_public_path__ + "assets/img/22.ac4e88df.png";